import type { ProjectSource, ProjectSourceId } from "@loumy/contracts";
import { CliSource, createCliSource, type CliConnection } from "./cliSource";
import { FileSystemAccessSource, isFileSystemAccessSupported } from "./fileSystemAccessSource";

// D69 — Katalog der wählbaren Projekt-Quellen (File→Open). Der Editor-Code ist quellen-agnostisch;
// die UI passt sich über `capabilities` der gewählten Quelle an. „Nichts referenziert eine Quelle hart":
// neue Adapter = ein Eintrag hier.

export interface ProjectSourceOption {
  readonly id: ProjectSourceId;
  readonly label: string;
  readonly description: string;
  /** FS-Access ist Chromium-only; eine nicht unterstützte Quelle wird ausgegraut. */
  isSupported(): boolean;
  /** CLI braucht eine Verbindung (Base-URL/Token) vor open() — FS-Access öffnet direkt den Picker. */
  readonly requiresConnection: boolean;
}

export const PROJECT_SOURCE_OPTIONS: ProjectSourceOption[] = [
  {
    id: "fs-access",
    label: "Lokaler Ordner",
    description: "Ordner-Picker im Browser (Zero-Install, Chromium). Manifest muss vorab existieren.",
    isSupported: isFileSystemAccessSupported,
    requiresConnection: false,
  },
  {
    id: "cli",
    label: "CLI (loumy serve)",
    description: "Über localhost verbunden — zusätzlich Live-Generierung & Watch. Cross-Browser.",
    isSupported: () => typeof fetch === "function",
    requiresConnection: true,
  },
];

/** Erzeugt eine FS-Access-Quelle (open() folgt in der UI). */
export function createFileSystemAccessSource(): FileSystemAccessSource {
  return new FileSystemAccessSource();
}

/** Erzeugt eine CLI-Quelle aus einer (validierten) Verbindung. */
export function createCliProjectSource(conn: CliConnection): CliSource {
  return createCliSource(conn);
}

/** Ob eine Quelle Löschen/Umbenennen kann (Port-`removeFile` + `capabilities.write`). */
export function canMutateFiles(source: ProjectSource): boolean {
  return source.capabilities.write && typeof source.removeFile === "function";
}
